export default "__VITE_ASSET__DtBbWqPg__"